import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CardTitleText: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', testId = TEST_ID, text } = props;

    return (
        <p className={`${className} ${styles.cardTitleText}`} data-testid={testId}>
            {children || text}
        </p>
    );
};

export default CardTitleText;
